export const UtmList = [
  "utm_source",
  "utm_content",
  "utm_term",
  "utm_medium",
  "utm_campaign",
  "source",
];
